export default "__VITE_PUBLIC_ASSET__3e4e63b3__"